import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  name: PropTypes.string.isRequired,
  wrapper: PropTypes.func,
  onClose: PropTypes.func,
  active: PropTypes.bool.isRequired,
  children: PropTypes.any.isRequired
};

var Parent = function Parent(_ref) {
  var children = _ref.children;
  return children();
};

var BlurLayer = function (_PureComponent) {
  _inherits(BlurLayer, _PureComponent);

  function BlurLayer(props) {
    _classCallCheck(this, BlurLayer);

    var _this = _possibleConstructorReturn(this, (BlurLayer.__proto__ || Object.getPrototypeOf(BlurLayer)).call(this, props));

    _this.onClose = function (e) {
      if (e && _this.node !== e.target) {
        return;
      }
      if (_this.props.onClose) {
        _this.props.onClose();
      }
    };

    _this.onMouseDown = function (e) {
      if (_this.node === e.target) {
        _this.setState({
          mouseDown: true
        });
      }
    };

    _this.onMouseUp = function (e) {
      if (_this.state.mouseDown && _this.node === e.target) {
        _this.onClose(e);
      }
      _this.setState({
        mouseDown: false
      });
    };

    _this.onKeyDown = function (e) {
      if (e.key === 'Escape' && _this.props.active && e.target === document.body) {
        _this.props.onClose();
      }
    };

    _this.state = {
      mouseDown: false
    };
    return _this;
  }

  _createClass(BlurLayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('keydown', this.onKeyDown, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.onKeyDown, false);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.active) {
        document.body.classList.add('noscroll');
      } else {
        document.body.classList.remove('noscroll');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          name = _props.name,
          active = _props.active,
          children = _props.children,
          wrapper = _props.wrapper;

      var Wrapper = wrapper || Parent;
      var className = name + '-layer blur-layer' + (active ? ' active' : '');
      return React.createElement(
        'div',
        {
          className: className,
          ref: function ref(_ref3) {
            return _this2.node = _ref3;
          },
          onMouseDown: this.onMouseDown,
          onMouseUp: this.onMouseUp,
          onTouchStart: this.onClose },
        React.createElement(
          Wrapper,
          { active: active, onClose: this.onClose },
          function () {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                moving = _ref2.moving,
                style = _ref2.style;

            return React.createElement(
              'div',
              {
                style: style,
                className: name + '-content layer-content' + (moving ? ' moving' : ''),
                onClick: function onClick(e) {
                  return e.stopPropagation();
                } },
              children
            );
          }
        )
      );
    }
  }]);

  return BlurLayer;
}(PureComponent);

BlurLayer.propTypes = propTypes;

export default BlurLayer;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/BlurLayer/index.js
// module id = 1137
// module chunks = 0